<template>
  <div class="wrapper">

    <ul class="garbage-calendar">

      <li v-if="!isToday(garbageCollection[0].date)">
        <div class="day today">
          {{ new Date() | moment('dddd D MMMM') }}

          <span class="today">
            Oggi
          </span>
        </div>
      </li>

      <li v-for="item in garbageCollection" :key="item.id">
        <div class="day" :class="isToday(item.date) ? 'today' : ''">
          {{ [ item.date, 'YYYY-M-D'] | moment('dddd D MMMM') }}

          <span class="today" v-if="isToday(item.date)">
            Oggi
          </span>
        </div>

        <ul class="garbages" v-if="item['container-type']">
          <li>
            <figure class="icon">
              <img :src="item['container-type'].icon" v-if="item['container-type'].icon" />

              <div class="image-placeholder" v-else></div>
            </figure>

            <h4 class="garbage-title">
              {{ item['container-type'].title }}
            </h4>
            <div class="description">
              {{ item.description }}
            </div>

          </li>
        </ul>
        <div class="no-collection" v-else>
          <span v-if="isToday(date)">
            Non sono previste raccolte per oggi
          </span>
          <span v-else>
            Non sono previste raccolte per questo giorno
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="less" scoped>
  .wrapper {
    margin: 20px;
    border: 0;

    .garbage-calendar {
      list-style: none;
      padding: 0;

      li:first-of-type {
        .day {
          border-top: 0;
        }
      }

      .day {
        position: relative;
        text-transform: capitalize;
        padding: 10px 0;
        font-weight: 900;
        font-size: 20px;
        border-top: 1px solid rgba(black, 0.1);
        border-bottom: 1px solid rgba(black, 0.1);

        &.today {
          display: flex;
          align-items: center;
          justify-content: space-between;

          &:after {
            content: "";
            position: absolute;
            top: 0;
            left: -20px;
            right: -20px;
            bottom: 0;
            background-color: rgba(var(--f7-theme-color-rgb), 0.10);
          }

          .today {
            font-size: 14px;
            font-weight: 900;
            color: rgba(var(--f7-theme-color-rgb), 0.7);
          }
        }
      }

      .no-collection {
        color: #999;
        font-size: 15px;
        font-weight: 500;
        padding: 15px 0 20px;
      }

      .garbages {
        list-style: none;
        padding: 0;

        li {
          margin: 10px 0;
          position: relative;
          padding-left: 60px;
          padding-bottom: 10px;
          width: auto;

          .icon {
            height: auto;
            width: 45px;

            top: 0;
            left: 0;
            padding: 0;
            margin: 0;
            position: absolute;
            display: block;

            img {
              width: 100%;
              height: auto;
            }

            .image-placeholder {
              background-color: #eee;
              height: 45px;
              width: 45px;
              border-radius: 3px;
            }
          }

          .garbage-title {
            font-size: 16px;
            margin: 0;
            font-weight: 900;
          }

          .description {
            color: #888;
            font-weight: 500;
            line-height: 1.2;
            font-size: 15px;
          }
        }
      }
    }

  }
</style>

<script>
  import moment from 'moment'
  import { getNextDays } from '../js/utils'

  export default {
    props: {
      days: {
        type: Number,
        default: 14,
        required: false,
      },

      garbageCollection: {
        type: Array,
        default: null,
        required: false,
      }
    },

    data() {

      return {
        dates: [],
      }
    },

    methods: {
      isToday(date) {
        const d = moment(date, 'YYYY-M-D')
        return moment().isSame(d, 'day')
      },

      getGarbagesForDate(date) {
        const d = moment(date, 'YYYY-M-D')
        const results = this.garbageCollections.filter((item) => {

          return moment(item.date, 'YYYY-M-D').isSame(d, 'day')
        })

        return results
      },
    },
    
    mounted() {
      this.dates = getNextDays(this.days)
    },
  }
</script>